import React from 'react';

interface FormFieldProps {
  label?: string;
  error?: string;
  required?: boolean;
  hint?: string;
  children: React.ReactNode;
  htmlFor?: string;
}

/** Wraps a form control with label and error message for consistent layout and a11y. */
export const FormField: React.FC<FormFieldProps> = ({
  label,
  error,
  required,
  hint,
  children,
  htmlFor,
}) => (
  <div className="space-y-1">
    {label && (
      <label
        htmlFor={htmlFor}
        className="block text-sm font-medium text-gray-700"
      >
        {label}
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>
    )}
    {children}
    {hint && !error && (
      <p className="text-xs text-gray-500 mt-0.5">{hint}</p>
    )}
    {error && (
      <p className="text-sm text-red-600 mt-1" role="alert">
        {error}
      </p>
    )}
  </div>
);
